import { ReactNode } from 'react'

import { astraTwMerge } from '../../Utilities/astraTwMerge'
import { Id } from '../types'
import { toCellId } from '../utils'

type Props<TRow extends { id: Id }, TCol extends { id: Id }> = {
    col: TCol
    row: TRow
    children: (row: TRow, col: TCol, isSelected: boolean) => ReactNode
    isCursor: boolean
    isSelected: boolean
    isRowSelected: boolean
    selectionBorders: string
    cellClassName?: (row: TRow, col: TCol) => string
    height?: number
}

const cursorStyles =
    "relative before:absolute before:bottom-0 before:right-0 before:z-priority before:h-px before:w-px before:rounded-full before:bg-brand-strong-rest before:content-[''] before:shadow-[0_0_0_5px_theme('backgroundColor.brand-strong-rest')]"

export const TableCell = <TCol extends { id: Id }, TRow extends { id: Id }>({
    col,
    row,
    children,
    isCursor,
    isSelected,
    isRowSelected,
    selectionBorders,
    cellClassName,
    height,
}: Props<TCol, TRow>) => (
    <div
        id={toCellId({ rowId: row.id, colId: col.id })}
        autoFocus={isCursor}
        tabIndex={isCursor ? 0 : -1}
        data-cell={`${row.id}_${col.id}`}
        data-row-id={row.id}
        data-col-id={col.id}
        style={{ height }}
        className={astraTwMerge(
            'group/cell relative h-full min-w-[28px] cursor-pointer self-stretch rounded-none border-b border-r bg-surface-base p-1 outline-none transition-all [&:nth-last-child(1_of[data-cell])]:border-r-0',
            cellClassName?.(row, col),
            selectionBorders,
            isRowSelected && !isSelected ? '!bg-surface-strong' : '',
            !isSelected ? 'hover:bg-surface-muted' : '',
            isCursor ? cursorStyles : ''
        )}
    >
        {children(row, col, isSelected)}
    </div>
)
